/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import React from "react";
import {Button, Drawer, Grid2, IconButton} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Contenido_Barra_Cell from "./Contenido_Barra_Cell";
import {theme} from "../../../../Tema";
import {useNavigate} from "react-router-dom";

const Pagina = () => {

    const [open, setOpen] = React.useState(false);

    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };

    return (
        <Grid2
            container
            justifyContent={'flex-end'}
            alignItems={'flex-start'}
            size={12}>
            <IconButton color={'secondary'} onClick={() => setOpen(true)}
                    sx={{
                        fontSize: 20,
                        color: 'white',
                        height: 50,
                        width: 50,
                        borderRadius: 10,
                        backgroundColor: theme.palette.primary.main}}
            >
                <MenuIcon sx={{}}/>
            </IconButton>

            <Drawer open={open}
                    onClose={toggleDrawer(false)}
                    anchor="right"
                    sx={{

                        '& .MuiDrawer-paper': {
                            width: '80%',
                            maxWidth: '80%px',
                            boxSizing: 'border-box',
                            backgroundColor: 'black'
                        },
                    }}
            >
                <Contenido_Barra_Cell setOpen={setOpen} />
            </Drawer>

        </Grid2>
    )

}
export default Pagina